<template>
  <div
    class="emd-container _type_card eu-mt_4"
    v-if="buildOrderCodeDetails()"
    data-testid="order-code-details"
  >
    <div class="emd-container__content ">
      <h2 class="el-chunk">{{ $t("orderCode.label") }}</h2>
      <p class='emd-text _size_small' style="overflow: hidden;">{{ $t(buildOrderCodeDetails()) }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderCodeDetails',
  methods: {
    buildOrderCodeDetails () {
      return this.$store.getters.orderCode
    }
  }
}
</script>
